angular
  .module('jv.App.DocuSignAuth.Svc', [])
  .service('docuSignSvc', function($http, $window) {
    var myAccountUrl = $window.jvUrls.admin + '/action/myAccount';

    this.saveDocuSign = function(data, flag, callback, fail) {
      var obj = {
        username: data.username,
        password: data.password,
        accountId: data.accountId
      };
      $http({
        url: myAccountUrl + '/authapps/docusign',
        method: 'POST',
        data: obj
      }).then(callback, fail);
    };
  });
